<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						

						<el-form-item :label="$t('source.cname')" class="mb-0">
							<el-input size="small" v-model="from.cname" ></el-input>
						</el-form-item>

						<el-form-item :label="$t('source.dns_name')" class="mb-0">
							<el-input size="small" v-model="from.dns_name" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
					</el-form>
					<div style="margin-top:10px">
						<!-- <el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('source.add')}}</el-button> -->
						<el-button size="small" v-if="layout.user.type==1" @click="getDnsName(false)" v-auth="'add'+auth_val" >{{$t('source.getDns')}}</el-button>
						<el-button size="small" v-if="layout.user.type==1" @click="alterDnsNameModel(false)" v-auth="'add'+auth_val" >{{$t('source.alterDns')}}</el-button>
						<el-button size="small" v-if="layout.user.type==1" @click="addSsl()" v-auth="'add'+auth_val" >{{$t('cdn.addSsl')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column
				      type="selection"
				      width="45">
				    </el-table-column>
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>

			
				<el-table-column  align="center" prop="name" :label="$t('source.name')" >
				</el-table-column>
			
				<el-table-column  align="center" prop="cname" :label="$t('source.cname')" >
				</el-table-column>
			
				<el-table-column  align="center" prop="dns_name" :label="$t('source.dnsName')" >
				</el-table-column>
			
				<el-table-column  align="center" prop="domain_count" :label="$t('source.domain_count')" width="150">
					<template slot-scope="scope">
						<span style="color: #999;">{{ scope.row.domain_count }}</span>
						/
						<span style="color: #999;">{{ scope.row.domain_sync_count }}</span>
						<span @click="checkDomainDetail(scope.row)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.domain_load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
					</template>
				</el-table-column>


				<el-table-column  align="center" prop="cert_count" :label="$t('source.cert_count')" width="150">
					<template slot-scope="scope">
						<span style="color: #999;">{{ scope.row.cert_count }}</span>
						/
						<span style="color: #999;">{{ scope.row.cert_sync_count }}</span>
						<span @click="checkCertDetail(scope.row)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.cert_load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="get_status" :label="$t('source.get_status')" width="100">
					<template slot-scope="scope">
						<span style="color: #999;" v-if="scope.row.get_status==3">{{$t('source.get_status3')}}</span>
						<span class="text-success" v-if="scope.row.get_status==1">{{$t('source.get_status1')}}</span>
						<span class="text-danger" v-if="scope.row.get_status==2">{{$t('source.get_status2')}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="sourceStr" :label="$t('source.sourceStr')" width="170">

				</el-table-column>
				
				<el-table-column prop="id" align="center" :label="$t('layout.operation')" >
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val"  @click="openModel(scope.row)">{{$t('layout.operation')}}</el-button>
							<el-button @click="syncCert(scope.row)" v-auth="'edit'+auth_val"  size="mini" plain type="success">{{$t('source.syncCert')}}</el-button>
							<el-button @click="syncDomain(scope.row)" v-auth="'edit'+auth_val"  size="mini" plain type="success">{{$t('source.syncDomain')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val"  size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
							<el-button @click="deleteDomain(scope.row)" v-auth="'del'+auth_val"  size="mini" plain type="danger">{{$t('source.deleteDomain')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('source.editSource') : $t('source.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('source.userName')" prop="user_id">
					<el-select v-model="form.user_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.allAccount" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item :label="$t('source.name')" prop="name">
					<el-input  v-model="form.name"  :placeholder="$t('source.name')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>

				<el-form-item :label="$t('source.sourceList')" prop="sourceList">
					<el-button @click="addSource(false)" style="margin-bottom: 10px;">{{ $t('source.addSource') }}</el-button>
								<el-table :data="form.sourceList" border style="width: 100%" @selection-change="handleSelectionChange">
									
									<el-table-column align="center" prop="type" :label="$t('source.type')">
										<template slot-scope="v">
											<el-tag v-if="v.row.type==1" >{{$t('source.type1')}}</el-tag>
											<el-tag v-if="v.row.type==2" >{{$t('source.type2')}}</el-tag>
										</template>
									</el-table-column>
									
									<el-table-column align="center" prop="source" :label="$t('source.source')"></el-table-column>
									<el-table-column align="center" prop="port" :label="$t('source.port')"></el-table-column>
									<el-table-column align="center" prop="weight" :label="$t('source.weight')"></el-table-column>
									<el-table-column align="center" prop="priority" :label="$t('source.priority')"></el-table-column>

									<el-table-column prop="id" align="center" width="140" :label="$t('layout.operation')">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addSource(scope)">{{ $t('layout.operation') }}</el-button>
												<el-button @click="delSource(scope)" :disabled="scope.row.is_default ? true : false" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
				</el-form-item>
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>



		
		<el-dialog :close-on-click-modal="false"   :title="editSourceIndex > -1 ? $t('source.editSource') : $t('source.addSource')" :append-to-body="true" :visible.sync="createSourceModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesSource" ref="formSource" :model="formSource" :label-width="layout.is_phone?'80px':'100px'">
							
					<el-form-item :label="$t('source.type')">
						<el-radio-group  v-model="formSource.type" size="small">
							<el-radio :label="1" border>{{$t('source.type1')}}</el-radio>
							<el-radio :label="2" border>{{$t('source.type2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				
					<el-form-item :label="$t('source.source')" prop="source">
						<el-input v-model="formSource.source" :placeholder="$t('source.source')" clearable size="small" style="width: 85%;" ></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.port')" prop="port">
						<el-input v-model="formSource.port" type="number" :placeholder="$t('source.port')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.weight')" prop="weight">
						<el-input v-model="formSource.weight" type="number" :placeholder="$t('source.weight')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item :label="$t('source.priority')" prop="priority">
						<el-input v-model="formSource.priority" type="number" :placeholder="$t('source.priority')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
					</el-form-item>
					
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createSourceModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitSource">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>


		
		<el-dialog :close-on-click-modal="false"   :title="editSourceDnsIndex > -1 ? $t('source.editSource') : $t('source.addSource')" :append-to-body="true" :visible.sync="createSourceDnsModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesDns" ref="formSourceDns" :model="formSourceDns" :label-width="layout.is_phone?'80px':'100px'">
							
					<el-form-item :label="$t('source.DnsType')">
						<el-radio-group  v-model="formSourceDns.type" size="small">
							<el-radio :label="1" border>{{$t('source.DnsType1')}}</el-radio>
							<el-radio :label="2" border>{{$t('source.DnsType2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				
					<el-form-item :label="$t('source.DnsName')" prop="source">
						<el-input v-model="formSourceDns.source" :placeholder="$t('source.DnsName')" clearable size="small" style="width: 85%;" ></el-input>
					</el-form-item>

				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createSourceDnsModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="alterDnsName">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createSourceDnsModel: false,
				editSourceDnsIndex: -1,
				formSourceDns:{
					type: 1,
					source: '',
				},

				createSourceModel: false,
				editSourceIndex: -1,

				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					dns_name: '',
					cname: '',
					user_id:-1,
					sourceList:[],
					time:[],
				},
				auth_val: 'Source',
				odds:0,
				preUrl: "data/sourceList", //列表地址
				delAllUrl: "data/delSourceAll", //批量删除地址
				delUrl: "data/delSource", //删除單条地址
				addUrl: "data/addCdnSource", //添加/修改地址
				editStatusUrl:"data/editStatusSource",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {
					name: '',
					user_id:'',
					sourceList:[]
				},
				

				rulesDns: {
					source: [{
						required: true,
						message: this.$t('source.sourceDnsRequired'),
						trigger: 'blur',
					}]
				},

				rules: {
					name: [{
						required: true,
						message: this.$t('userList.nameRequired'),
						trigger: 'blur',
					}],
					sourceList: [{
						required: true,
						message: this.$t('source.sourceListRequired'),
						trigger: 'blur',
					}],
					user_id: [{
						required: true,
						message: this.$t('source.selUser'),
						trigger: 'blur',
					}],
				},
				
				formSource:{
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				},
				rulesSource: {
					source: [
						{
							required: true,
							message: this.$t('userList.sourceRequired'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (!value) {
									return callback();
								}

								const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
								const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

								if (domainRegex.test(value) || ipRegex.test(value)) {
									callback();
								} else {
									callback(new Error('请输入有效的域名或IP地址'));
								}
							},
							trigger: 'blur'
						}
					],
					port: [{
						required: true,
						message: this.$t('userList.portRequired'),
						trigger: 'blur',
					}],
					weight: [{
						required: true,
						message: this.$t('userList.weightRequired'),
						trigger: 'blur',
					}],
					priority: [{
						required: true,
						message: this.$t('userList.priorityRequired'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['user']);
		},
		methods: {
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('source.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('source.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			alterDnsNameModel(){
				if(this.ids.length==0){
					this.$message.error(this.$t('source.selSource'));
					return false
				}
				this.formSourceDns = {
					type: 1,
					source: '',
				},
				this.createSourceDnsModel = true;
			},
			alterDnsName(){
				this.$refs.formSourceDns.validate(res => {
					if (res) {
						this.layout.loading = true;
						this.formSourceDns.ids = this.ids
						this.axios.post('/admin/data/alterDnsName', this.formSourceDns, {
							token: true,
						}).then(res => {
							this.layout.loading = false;
							this.$message.success(this.$t('source.alterDnsSuccess'));
							this.getList()
							this.createSourceDnsModel = false;
						}).catch(err => {
							// 失敗
							this.layout.loading = false;
							this.$message.error(this.$t('source.alterDnsFailed'));
						})
					}
				})
				
			},
			checkDomainDetail(item) {
				if(item.domain_load==1){
					return false;
				}
				item.domain_load = 1;
				this.axios.post('/admin/data/checkDomainDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					item.domain_sync_count = list.domain_sync_count
					item.domain_count = list.domain_count
					
					item.domain_load = 0;
					this.$message.success(this.$t('source.checkDomainSuccess'));
				}).catch(err => {
					// 失敗
					item.domain_load = 0;
					this.$message.error(this.$t('source.checkDomainFailed'));
				})
			},

			deleteDomain(item) {
				this.$confirm(this.$t('source.confirmDeleteDomain'), this.$t('system.delete'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.axios.post('/admin/data/delSourceDomainAll', {
						id:item.id
					}, {
						token: true,
					}).then(res => {
						this.layout.loading = false;
						this.$message.success(this.$t('system.deleteSuccess'));
						this.getList()
					}).catch(err => {
						// 失敗
						this.layout.loading = false;
						this.$message.error(this.$t('system.deleteFailed'));
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('system.cancel')
					});
				});
			},

			getDnsName() {
				if(this.ids.length==0){
					this.$message.error(this.$t('source.selSource'));
					return false
				}
				this.layout.loading = true;
				this.axios.post('/admin/data/getDnsName', {
					ids:this.ids
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.$message.success(this.$t('source.getDnsSuccess'));
					this.getList()
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
					this.$message.error(this.$t('source.getDnsFailed'));
				})
			},

			addSsl() {
				if(this.ids.length==0){
					this.$message.error(this.$t('source.selSource'));
					return false
				}

				this.layout.loading = true;
				this.axios.post('/admin/data/addSsl', {
					source_id:this.ids
				}, {
					token: true,
				}).then(res => {
					// let all = res.data
					// let list = all.data
					this.$message.success(this.$t('cdn.addSslSuccess'));
					this.getList(); 
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
					this.$message.error(this.$t('cdn.addSslFailed'));
				})
			},

			checkCertDetail(item) {
				if(item.cert_load==1){
					return false;
				}
				item.cert_load = 1;
				this.axios.post('/admin/data/checkCertDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					item.cert_sync_count = list.cert_sync_count
					item.cert_count = list.cert_count
					
					item.cert_load = 0;
					this.$message.success(this.$t('source.checkCertSuccess'));
				}).catch(err => {
					// 失敗
					item.cert_load = 0;
					this.$message.error(this.$t('source.checkCertFailed'));
				})
			},
			syncCert(e){
				this.layout.loading = true;
				this.axios.post('/admin/data/syncCert', {
					id:e.id
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.$message.success(this.$t('source.syncCertSuccess'));
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
					this.$message.error(this.$t('source.syncCertFailed'));
				})
			},
			syncDomain(e){
				this.layout.loading = true;
				this.axios.post('/admin/data/syncDomain', {
					id:e.id
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.$message.success(this.$t('source.syncDomainSuccess'));
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
					this.$message.error(this.$t('source.syncDomainFailed'));
				})
			},
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						name: '',
						user_id:'',
						sourceList:[]
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						name: e.name,
						user_id: e.uid,
						sourceList:e.sourceList,
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			delSource(scope){
				// 獲取要刪除的名次 ID 或索引
				const index = scope.$index; // 行的索引
				this.form.sourceList.splice(index, 1); // 刪除對應行
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},

			//添加修改源站列表
			addSource(e = false){
				if (!e) {
					// 初始化表單
					this.editSourceIndex = -1
				} else {
					// 修改
					this.formSource = {
						source: e.row.source,
						id: e.row.id,
						type: e.row.type,
						port: e.row.port,
						weight:e.row.weight,
						priority:e.row.priority,
					}
					this.editSourceIndex = e.$index
				}
			
				// 打开dialog
				this.createSourceModel = true
			},
			submitSource(){
				console.log(this.formSource)
				this.$refs.formSource.validate(valid => {
					if (valid) {
						if (this.editSourceIndex === -1) {
							// 添加新題目
							this.form.sourceList.push(this.formSource);
						} else {
							// 修改现有題目
							this.$set(this.form.sourceList, this.editSourceIndex, {...this.formSource});
						}
						
						// 重置表單和關閉模态框
						this.resetSourceForm();
					}
				});
			},
			resetSourceForm(){
				this.formSource = {
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				}
				this.editSourceIndex = -1;
				this.createSourceModel = false;
			},
			// deleteItemSource(item) {
			// 	//询问层
			// 	this.$confirm(this.$t('source.confirmDelete'), this.$t('system.delete'), {
			// 		confirmButtonText: this.$t('system.confirm'),
			// 		cancelButtonText: this.$t('system.cancel'),
			// 		type: 'warning'
			// 	})
			// 	.then(() => {
			// 		this.deleteItem(item);
			// 	})
			// 	.catch(() => {
			// 		this.$message({
			// 			type: 'info',
			// 			message: this.$t('system.cancel')
			// 		});
			// 	});
			// },
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					dns_name: '',
					cname: '',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
